import React, { useCallback, useEffect, useState } from 'react';
import { fetchPrivacy } from '../../reducers/auth/auth.actions';
import { useDispatch, useSelector } from 'react-redux';

const Privacy = () => {
  const dispatch = useDispatch();
  const [privacy, setPrivacy] = useState();

  useEffect(() => {
    dispatch(fetchPrivacy()).then(resp => {
      setPrivacy(resp)
    })
  }, [dispatch]);
  return (

    <div className="container static-pages">
      {privacy && (
        <>
          <h3 className="text-center mt-3">{privacy.title}</h3>
          <hr />
          <p>
            {privacy.content}
          </p>
        </>
      )}
      <p></p>
    </div>
  );
};

export default Privacy;
